/*
* 2007-2014 PrestaShop
*
* NOTICE OF LICENSE
*
* This source file is subject to the Academic Free License (AFL 3.0)
* that is bundled with this package in the file LICENSE.txt.
* It is also available through the world-wide-web at this URL:
* http://opensource.org/licenses/afl-3.0.php
* If you did not receive a copy of the license and are unable to
* obtain it through the world-wide-web, please send an email
* to license@prestashop.com so we can send you a copy immediately.
*
* DISCLAIMER
*
* Do not edit or add to this file if you wish to upgrade PrestaShop to newer
* versions in the future. If you wish to customize PrestaShop for your
* needs please refer to http://www.prestashop.com for more information.
*
*  @author PrestaShop SA <contact@prestashop.com>
*  @copyright  2007-2014 PrestaShop SA
*  @license    http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
*  International Registered Trademark & Property of PrestaShop SA
*/
$(document).ready(function(){
	$(document).on('click', '.lnk_more', function(e){
		e.preventDefault();
		$('#category_description_short').hide(); 
		$('#category_description_full').show(); 
		$(this).hide();
	});

    $('.nuancier-img').hover(
        function () {

            const $img = $(this);
            const hoverSrc = $img.data('hover');
            if (hoverSrc) {
                $img.data('original-src', $img.attr('src')); // stocke l'original au survol
                $img.prop('src', hoverSrc);
                console.log($img.attr('src'), $img.data('original-src'));
            }
        },
        function () {
            const $img = $(this);
            const originalSrc = $img.data('original-src');
            if (originalSrc) {
                $img.attr('src', originalSrc);
            }
        }
    );

	/* création d'un bouton pour cacher et afficher la description d'une catégorie */
	//btn
    
	var $input_btn = $('<button id="savoir">En savoir plus</button>');
	//on cache la description en dessous de la div#ensavoirplus
	$("div#ensavoirplus").nextAll().hide();
	//affiche btn
    $input_btn.appendTo($("div#ensavoirplus"));
	//affichage de la description au clic
    $("#savoir").click(function(){
      $(this).hide();
      $(this).parent("div#ensavoirplus").nextAll().fadeIn(500);
    });

    $(document).on('mouseenter', '.product_img_link img', function(){
        var $this = $(this);
        var $secondeIMG = $this.data('secondimage');
        if($secondeIMG){
            $this.prop("src", $secondeIMG);
        }
    });

    $(document).on('mouseleave', '.product_img_link img',  function (){
        var $this = $(this);
        var $firstIMG = $this.data('firstimage');
        $this.prop("src", $firstIMG);
    });
});